import { render, staticRenderFns } from "./ModalYesNo.vue?vue&type=template&id=856ae930&scoped=true&"
import script from "./ModalYesNo.vue?vue&type=script&lang=js&"
export * from "./ModalYesNo.vue?vue&type=script&lang=js&"
import style0 from "./ModalYesNo.vue?vue&type=style&index=0&id=856ae930&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856ae930",
  null
  
)

export default component.exports